import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ModuleId } from '../../../shared/store/navigation/types';
import { InsuranceClaimCreateComponent } from './insurance-claim-create/insurance-claim-create.component';
import { InsuranceClaimDetailsComponent } from './insurance-claim-details/insurance-claim-details.component';
import { InsuranceClaimEditComponent } from './insurance-claim-edit/insurance-claim-edit.component';

const routes: Routes = [
  {
    path: 'Insurance/InsuranceClaims',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceClaim,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:uniqueId',
        component: InsuranceClaimDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceClaim,
          breadcrumb: { label: ' ', alias: 'insuranceClaimDetails' },
        },
      },
      {
        path: 'Edit/:uniqueId',
        component: InsuranceClaimEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceClaim,
          breadcrumb: { label: ' ', alias: 'insuranceClaimEdit' },
        },
      },
      {
        path: 'Create',
        component: InsuranceClaimCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceClaim,
          breadcrumb: { label: ' ', alias: 'insuranceClaimCreate' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InsuranceClaimRoutingModule {}
